module.exports = __webpack_public_path__ + "img/cooperate_18.26c15f6d.png";